const index = () => import(/* webpackChunkName: "herb" */ './Index');

export default {
  routes: [
    //项目
    {
      path: '/internetPlatform/2019/index',
      name: 'internetPlatform2019Index',
      component: index,
      meta:{public:true}
    }
  ]
}



// WEBPACK FOOTER //
// ./src/components/special/internet/platform/v2019/router.js